<template>
    <div class="h-100 bg-gray7 d-flex align-center justify-center">
        <div>
            <div class="d-flex align-center justify-center">
                <div>
                    <v-img
                        :src="require('@/assets/img/404-item-1.png')"
                        :width="$vuetify.breakpoint.mdAndUp ? 223 : ($vuetify.breakpoint.smAndDown ? 179 : 40)"
                        alt=""
                    />
                </div>
            </div>

            <p 
                class="le-heading3 text-center"
                :class="{
                    'mt-10': $vuetify.breakpoint.smAndUp,
                    'mt-8': $vuetify.breakpoint.xsOnly
                }"
            >
                <template v-if="$route.params.lang !== 'eng'">
                    죄송합니다.<br>
                    페이지를 찾을 수 없습니다.
                </template>

                <template v-else>
                    Sorry.<br>
                    The page you’re looking for can’t be found.
                </template>
            </p>

            <div 
                class="d-flex align-center justify-center"
                :class="{
                    'mt-16': $vuetify.breakpoint.smAndUp,
                    'mt-11': $vuetify.breakpoint.xsOnly
                }"
            >
                <v-btn
                    :to="homeTo"
                    color="orange1"
                    :large="$vuetify.breakpoint.mdAndUp"
                    depressed
                    class="text-white1"
                    exact
                >
                    {{ $route.params.lang === 'eng' ? 'Go to Home' : '메인으로' }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFoundPage',
    components: {        
        // Swiper,
    },

    data: function() {
        return {
            //
        };
    },

    computed: {
        homeTo() {
            const lang = this.$route.params.lang === 'eng' ? 'eng' : 'kor';
            return { name: 'HomePageSelectedLanguage', params: { lang } };
        }
    },
    
    metaInfo() {
        const isEng = this.$route.params.lang === 'eng';
        return {
            title: isEng ? 'Page Not Found' : '페이지를 찾을 수 없습니다',
            titleTemplate: '%s | Learn for the Future',
            script: [{ src: 'https://lecos.co.kr/clarity-lecos-korea/tracking.js', async: true, defer: true }],
        };
    },

    created() {
        //
    },

    mounted() {
        //
    },

    beforeDestroy() {
        //
    },

    methods: {
        //
    }
};
</script>